import React, { useEffect, useState } from "react";
import "react-phone-input-2/lib/material.css";
import _ from "lodash";
import { loggedInUser } from "../utils/store";
import { useAtom } from "jotai";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Loader from "../components/Loader";
import { SHARED_COUPON_DETAILS } from "../utils/constants/apiUrl";
import { get } from "../server";
import showToast from "../helpers/showToast";
import { Button, Card } from "react-bootstrap";
import logo from "../assets/images/signup_icons/logo-dark.svg";
import box from "../assets/images/surprise-red-gift-box.png";
import scissors from "../assets/images/scissors.png";

const PublicCoupon = () => {
  const [loading, setLoading] = useState(false);
  const [couponDetails, setCouponDetails] = useState(null);
  const [couponMessage, setCouponMessage] = useState("");

  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);

  const location = useLocation();

  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const coupon = params.get("coupon");
  // const id = params.get("id");
  console.log("coupon", coupon);
  const fetchSingleContact = async () => {
    setLoading(true);

    let { status, message, data } = await get(
      `${SHARED_COUPON_DETAILS}?coupon=${coupon}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      setCouponMessage(message);
      setCouponDetails(data);
    } else {
      // showToast(status, message);
      setCouponMessage(message);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchSingleContact();
  }, []);

  const handleSignUp = () => {
    navigate(`/signup?coupon=${coupon}`);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="public-coupon-page">
      <div className="container h-100">
        <div className="row justify-content-center align-items-center h-100">
          <div className="col-md-5 col-12">
            <Card className="shadow text-center">
              <Card.Body>
                {couponDetails !== null ? (
                  <>
                    <img src={logo} alt="" className="d-block mx-auto logo" />
                    <img src={box} alt="" className="d-block mx-auto" />
                    <h1>Surprise!</h1>
                    <p className="subtitle">Your special gift is waiting.</p>
                    <p className="package-text">
                      Your{" "}
                      <span className="pkg-name">
                        {couponDetails?.package?.package_name}
                      </span>{" "}
                      {couponDetails?.duration_type} Package Is{" "}
                      <span className="pkg-val">
                        {couponDetails?.discount === 100
                          ? "Completely FREE"
                          : `${couponDetails?.discount}% Off`}
                      </span>
                    </p>
                    <p>Claim your coupon</p>
                    <div className="coupon-code-wrapper">
                      {`${couponDetails?.coupon_code_text[0]?.coupon}`}
                      <img src={scissors} alt="" className="" />
                    </div>
                    <Button
                      variant="primary"
                      onClick={() =>
                        navigate(`/login?coupon=${coupon}`, {
                          state: { couponVal: couponDetails?.discount },
                        })
                      }
                      className="rounded-pill mb-3"
                    >
                      LOG IN
                    </Button>
                    <Button
                      variant="outline-dark"
                      // onClick={handleSignUp}
                      onClick={() =>
                        navigate(`/signup?coupon=${coupon}`, {
                          state: { couponVal: couponDetails?.discount },
                        })
                      }
                      className="rounded-pill"
                    >
                      ARE YOU A NEW USER
                    </Button>
                    <div className="mt-4 text-center">
                      <p>
                        Start with our{" "}
                        <a
                          href="https://contactco.com/pages/how-to-use-app"
                          target="_blank"
                          className="btn btn-link setup-link p-0"
                        >
                          Setup Guide
                        </a>
                      </p>
                    </div>
                  </>
                ) : (
                  <h1 className="mb-0">{couponMessage}</h1>
                )}
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicCoupon;
